import React, { FC } from "react";
import { Stack, Typography } from "@mui/material";
import Markdown from "@components/Markdown";

interface Props {
  content: string;
}

const MarkdownBlock: FC<Props> = ({ content }) => {
  return (
    <Stack>
      <Markdown content={content} />
    </Stack>
  );
};

export default MarkdownBlock;
